import { useState, useEffect } from 'react';
import { Container } from './styled';
import { FaCheck } from "react-icons/fa";

export function CheckBox(props) {

    const {
        onChange,
        initialValue
    } = props;

    const [isChecked, setIsChecked] = useState(false);

    useEffect(() => {
        setIsChecked(initialValue)
    }, [initialValue])

    function handleChecked() {
        setIsChecked(!isChecked)
        onChange(!isChecked);
    };

    return (
        <Container
            isChecked={isChecked}
            onClick={() => handleChecked()}
        >
            {isChecked && <FaCheck className='check-icon' />}
        </Container>
    );
};